
import '../App.css';
import React, { useState, useEffect, useRef, forwardRef } from 'react';
import logo from '../logo.png'
import { useLocation, useNavigate } from 'react-router-dom';
import moment, { duration } from 'moment/moment';
import { FaUserFriends } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import { add_icon, add_image, add_video, delete_icon, view_icon } from '../assets/Icons';
import { IoIosCloseCircle } from "react-icons/io";
import { db, storage } from '../config';
import { decrypt, encrypt } from '../Crypto';
import { MdAddPhotoAlternate } from "react-icons/md";
import { RiVideoAddFill } from "react-icons/ri";
import { Levels } from 'react-activity';
import "react-activity/dist/library.css";
import Select, { components } from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from 'react-redux';
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
import { FaRegCheckSquare } from "react-icons/fa";
import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { Collapse } from 'react-collapse';
import { SetId } from './redux/actions';
import BackDrop from './Backdrop';
import { VscThreeBars } from 'react-icons/vsc';

//import { Collapse } from "react-collapse";
import { FiImage, FiClock, FiSettings } from "react-icons/fi";

const userdb = db.ref('userdb');

const calendardb = db.ref('calendardb');

const serialdb = db.ref('serialdb');


const recruiter_active = <FaUserTie color='white' size={22} />
const recruiter_active_non = <FaUserTie color='#B9B9B9' size={22} />



function Calendars({ items, SetId }) {

  const [aiOpen, setAiOpen] = useState(false);

  const AiSubItem = ({ icon, label, onClick }) => (
    <div
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 14,
        height: 52,
        paddingLeft: 18,
        paddingRight: 20,
        marginBottom: 8,
        borderRadius: 12,
        backgroundColor: "transparent",
      }}
    >
      <div
        style={{
          width: 22,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#9AA4B2",
        }}
      >
        {icon}
      </div>

      <span
        style={{
          fontSize: label === "Create Images" ? 13 : 15,
          fontWeight: 600,
          lineHeight: "1",
          color: "#9AA4B2",
          textAlign: "left",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
    </div>
  );

  const AiLeftSubMenuDesktop = () => {
    return (
      <div
        style={{
          display: "flex",
          width: width * 0.14,
          //  alignSelf: "center",
          marginTop: 8,
          // justifyContent: "center", // center whole block
          marginLeft: 52,
        }}
      >
        {/* inner aligned block */}

        {/* vertical line */}
        <div
          style={{
            width: 4,
            backgroundColor: "#2E3642",
            borderRadius: 4,
            marginRight: 14,
          }}
        />

        {/* menu items */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start", // text stays left aligned
          }}
        >
          <AiSubItem
            icon={<FiImage />}
            label="Create Images"
            onClick={() => {
              if (items.devices > 0) {
                navigate("/AICreate")
                // Do something if devices are available
              }
              else toast('Add a Boom Display Device before using Ai')
            }}
          />

          <AiSubItem
            icon={<FiClock />}
            label="History"
            onClick={() => navigate("/AIGenerator")}
          />

          <AiSubItem
            icon={<FiSettings />}
            label="Settings"
            onClick={() => navigate("/AISetting")}
          />
        </div>


      </div>
    )
  };


  const [edit_second, setEditSecond] = useState(null)
  const [second, setSecond] = useState(0)

  const key = items.myid != null ? items.myid.id : null

  useEffect(() => {
    if (items.myid == null) {
      let obj = localStorage.getItem('display')
      if (obj != null) { obj = JSON.parse(obj); SetId(obj) }
      else { navigate('/') }
    }
  }, [items])

  let curr = new Date().getTime();

  const navigate = useNavigate();


  const [touched1, setTouched1] = useState(false);

  const [startDate, setStartDate] = useState(new Date().getTime())

  const [endDate, setEndDate] = useState(new Date().getTime())

  function generate_timing() {
    let arr = []
    for (let i = 1; i < 12; i++) {
      for (let j = 0; j < 60; j = j + 15) {
        arr.push({ value: ret_double(i) + " : " + ret_double(j), label: ret_double(i) + " : " + ret_double(j), hour: i, min: j })
      }
    }
    arr.push({ value: ret_double(12) + " : " + ret_double(0), label: ret_double(12) + " : " + ret_double(0), hour: 12, min: 0 })
    return arr
  }

  const [times, setTimes] = useState(generate_timing())


  function generate() {
    let arr = []
    for (let i = 0; i < 59; i++) {
      arr.push({ label: i + " s", value: i + " s", sec: i })
    }
    for (let i = 2; i < 6; i++) {
      arr.push({ label: i + " min", value: i + " min", sec: i * 60 })
    }
    return arr
  }

  const seconds = generate()

  function toggleTouched1() {
    setTouched1(!touched1);
  }

  function handleMouseUp1() {
    // Handle smooth animation when clicking without holding
    setTimeout(() => {
      setTouched1(!touched1);
    }, 150);
  }

  const [addImage, setAddImage] = useState(false)
  const [addVideo, setAddVideo] = useState(false)

  const [mycontent, setMycontent] = useState([])
  const [devices, setDevices] = useState([])


  const [picture, setPicture] = useState(null)
  const [imguri, setimguri] = useState(null)


  const [loading, setLoading] = useState(null)

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  useEffect(() => {
    const subscribe = userdb.child(String(key)).child('content').on('value', (snapshot) => {
      if (snapshot != undefined && snapshot.val() != null) {
        let arr = Object.values(snapshot.val());
        for (let i = 0; i < arr.length; i++) {
          arr[i].label = decrypt(arr[i].name) + `( ${arr[i].type} )`
          arr[i].value = decrypt(arr[i].name) + `( ${arr[i].type} )`
        }
        setMycontent([...arr])
      }
    })
    return () => subscribe()
  }, [key])

  useEffect(() => {
    const subscribe = userdb.child(String(key)).child('devices').on('value', (snapshot) => {
      if (snapshot != undefined && snapshot.val() != null) {
        let arr = Object.values(snapshot.val());
        for (let i = 0; i < arr.length; i++) {
          arr[i].label = decrypt(arr[i].name)
          arr[i].value = decrypt(arr[i].name)
        }
        let obj = { label: 'All', value: 'All' }
        arr.unshift(obj)
        setDevices([...arr])
      }
      else {
        setDevices([])
      }
    })
    return () => subscribe()
  }, [key])


  const [mainSetup, setMainSetup] = useState([])
  const [mainAll, setMainAll] = useState([])

  async function getpreviousDayWork(key) {
    let now = new Date()
    now.setHours(1)
    now.setMinutes(0)
    now.setSeconds(0)
    now.setMilliseconds(0)
    now = now.getTime()
    let val = await calendardb.child(String(key)).orderByChild('end_dat').endAt(String(now)).once('value')
    val = val.val()

    console.log('Filtered  ...............', val)

  }

  async function getAllUsers() {
    let all = await db.ref('Sign_up').once('value')
    if (all.val() != null) {
      let arr = Object.values(all.val())
      for (let i = 0; i < arr.length; i++) {
        await getpreviousDayWork(arr[i].id)
      }
    }
  }

  useEffect(() => {
    getAllUsers()
  }, [])

  async function gettingAll() {
    let snapshot = await calendardb.child(String(key)).once('value')
    if (snapshot != undefined && snapshot.val() != null) {
      let arr = Object.values(snapshot.val());
      let tod = new Date()
      tod.setHours(11)
      tod.setMinutes(0)
      tod.setSeconds(0)
      tod.setMilliseconds(0)
      tod = tod.getTime()
      let temp = []
      for (let i = 0; i < arr.length; i++) {
        arr[i].id = String(arr[i].ID)
        console.log(decrypt(arr[i].device.name), ' ', ' ', tod)
        if (Number(arr[i].end_dat) <= tod || Number(arr[i].end_dat) >= tod) {
          temp.push(arr[i])
        }
      }
      temp.sort(function (a, b) { return a.index - b.index });
      setMainAll([...temp])
    }
    else setMainAll([])

  }



  useEffect(() => {
    gettingAll()
  }, [key])

  const ref = useRef()
  const ref1 = useRef()

  const handleClick = (e) => {
    ref.current.click()
  }

  const onChangePicture = e => {
    if (e.target.files[0]) {
      // console.log("picture: ", e.target.files);
      let file = e.target.files[0]; // get the supplied file
      //setPicture(e.target.files[0]);
      const reader = new FileReader();
      if (file) {
        reader.addEventListener("load", () => {
          // uploadToFirebase(file);
          setPicture(reader.result);
          console.log('Details ', file)
          setimguri(file)
        });
      }
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const [delete_content, setDeleteContent] = useState(false)

  async function delet_content() {
    await calendardb.child(String(key)).child(String(delete_content)).remove()
    toast('Content is deleted !')
    gettingAll()
    setDeleteContent(false)
  }

  const [modal, setModal] = useState(false)

  function today_dat(str) {
    return new Date(str).getDate() + " " + months[new Date(str).getMonth()] + " " + new Date().getFullYear()
  }

  const DateInput1 = forwardRef(
    ({ onClick, value }, ref) => (
      <div ref={ref} onClick={onClick} style={{ zIndex: 1000, width: 225, display: 'flex', backgroundColor: 'white', height: 38, borderRadius: 4, justifyContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 4 }}>
        <text style={{ color: 'black', fontWeight: '400', fontSize: 15, }}>{today_dat(startDate)}</text>
      </div>
    )
  );

  const DateInput2 = forwardRef(
    ({ onClick, value }, ref) => (
      <div ref={ref} onClick={onClick} style={{ zIndex: 1000, width: 225, display: 'flex', backgroundColor: 'white', height: 38, borderRadius: 4, justifyContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 4 }}>
        <text style={{ color: 'black', fontWeight: '400', fontSize: 15, }}>{today_dat(endDate)}</text>
      </div>
    )
  );

  const [curr_device, setCurrDevice] = useState(null)
  const [curr_content, setCurrContent] = useState(null)
  const [timing, setTiming] = useState(0)

  const [start, setStart] = useState(null)
  const [end, setEnd] = useState(null)

  console.log('Key ', key, '  ', items.myid)

  async function updateTiming() {
    if (edit_second != null && second != 0) {
      console.log('Edit oen ', edit_second)
      await calendardb.child(String(key)).child(String(edit_second.ID)).update({ timing: second })
      setEditSecond(null)
      setSecond(0)
      gettingAll()
      toast('Timing has been updated')
    }
  }

  const { state } = useLocation();
  const [ai_image, setAiImage] = useState(false)

  async function adding_to_folder_automatic(image_id, generateImageBase64) {
    let folder_obj = {
      ID: 12345,
      name: encrypt('AI Generated Folder')
    }
    await userdb.child(String(key)).child('folder').child(String(folder_obj.ID)).set(folder_obj)
    let count = 0;
    count = (await userdb.child(String(key)).child('content').orderByChild('folder').equalTo(12345).once('value')).numChildren()
    let content_obj = {
      ID: image_id,
      folder: folder_obj.ID,
      name: encrypt(`AI Generated Image_${count + 1}`),
      type: 'image',
      upload: encrypt(`AI Generated Image_${count + 1}`),
      uri: generateImageBase64
    }
    let exist = (await userdb.child(String(key)).child('content').child(String(content_obj.ID)).once('value')).val()
    if (exist == null) {
      await userdb.child(String(key)).child('content').child(String(content_obj.ID)).set(content_obj)
    }
  }

  useEffect(() => {
    if (state != null && state.curr_content != undefined) {
      setCurrContent(state.curr_content)
      setAiImage(true)
      setModal(true)
    }
  }, [])

  async function add_to_calendar2() {
    if (curr_device != null && curr_content != null && timing != 0 && ((start != null && end != null && end.type != undefined && start.type != undefined) || full_time)) {
      let ID = new Date().getTime()
      let obj = {
        ID: ID,
        start_dat: String(new Date(startDate).getTime()),
        end_dat: String(new Date(endDate).getTime()),
        device: curr_device,
        content: curr_content,
        timing: timing,
        start: start,
        end: end,
        full_time,
        URL: urlInput == '' ? null : urlInput
      }

      await calendardb.child(String(key)).child(String(ID)).set(obj)
      if (curr_device != 'All') toast(`${decrypt(curr_content.name)} has been added to device ${decrypt(curr_device.name)}`)
      else toast(`${decrypt(curr_content.name)} has been added to all devices`)

      gettingAll()
      setStart(null)
      setEnd(null)
      setCurrContent(null)
      setCurrDevice(null)
      setTiming(0)
      setStartDate(new Date().getTime())
      setEndDate(new Date().getTime())
      setModal(false)
      setFullTime(false)

      if (ai_image) {
        await adding_to_folder_automatic(curr_content.ID, curr_content.uri)
        setAiImage(false)
      }

    }

    else toast('Empty fields are not accepted !')
  }


  async function add_to_calendar() {
    const isValidUrlFormat = (value) => {
      try {
        if (!value || typeof value !== "string") return false;
        const parsed = new URL(value.trim());
        return parsed.protocol === "http:" || parsed.protocol === "https:";
      } catch (err) {
        return false;
      }
    };

    const finalContent = showUrlField
      ? {
        ID: "__external_url__",
        name: "External Url",
        uri: urlInput.trim(),
        type: "url",
      }
      : curr_content;

    if (showUrlField) {
      if (!urlInput || !urlInput.trim()) {
        toast("Please enter a url!");
        return;
      }

      if (!isValidUrlFormat(urlInput)) {
        toast("Please enter a valid url starting with http:// or https://");
        return;
      }
    }

    if (
      curr_device != null &&
      finalContent != null &&
      timing != 0 &&
      ((start != null && end != null && end.type != undefined && start.type != undefined) || full_time)
    ) {
      let ID = new Date().getTime();

      let obj = {
        ID: ID,
        start_dat: String(new Date(startDate).getTime()),
        end_dat: String(new Date(endDate).getTime()),
        device: curr_device,
        content: finalContent,
        timing: timing,
        start: start,
        end: end,
        full_time,
        URL: showUrlField ? urlInput.trim() : null,
      };

      await calendardb.child(String(key)).child(String(ID)).set(obj);

      if (curr_device != 'All') {
        toast(
          `${showUrlField ? "External Url" : decrypt(finalContent.name)} has been added to device ${decrypt(curr_device.name)
          }`
        );
      } else {
        toast(`${showUrlField ? "External Url" : decrypt(finalContent.name)} has been added to all devices`);
      }

      gettingAll();
      setStart(null);
      setEnd(null);
      setCurrContent(null);
      setCurrDevice(null);
      setTiming(0);
      setStartDate(new Date().getTime());
      setEndDate(new Date().getTime());
      setModal(false);
      setFullTime(false);
      setShowUrlField(false);
      setUrlInput("");

      if (ai_image && !showUrlField) {
        await adding_to_folder_automatic(finalContent.ID, finalContent.uri);
        setAiImage(false);
      }
    } else {
      toast('Empty fields are not accepted !');
    }
  }

  function ret_double(str) {
    let st = String(str)
    if (st.length == 1) return '0' + st
    else return st
  }

  const [curr_duration, setCurrDuration] = useState(0)


  function float2int(value) {
    return value | 0;
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    //setSetups([...result])
    return result;
  };
  // quote.content.uri

  function Quote({ quote, index }) {
    // console.log('Quote ...',quote)
    return (
      !isMobile ? <Draggable draggableId={quote.id} index={index}>
        {provided => (
          <div onClick={(e) => { setDeleteContent(quote.ID) }} style={{ height: 60, width: 0.74 * width, backgroundColor: 'white', display: 'flex', alignSelf: 'center', justifyContent: 'space-between', alignContent: 'center' }}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div onClick={(e) => { setDeleteContent(quote.ID) }} onMouseLeave={() => { setCursorImg(null); setCursorVid(null) }} onMouseEnter={() => { if (quote.content.type == 'image') { setCursorImg(quote.content.uri); setCursorVid(null) } else { setCursorVid(quote.content.uri); setCursorImg(null) } }} style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>
              <div style={{ display: 'flex', height: 56, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5, flexDirection: 'column' }}>
                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{today_dat(Number(quote.start_dat))}</text>
                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center', marginTop: 4 }}>{today_dat(Number(quote.end_dat))}</text>
              </div>
              {quote.device != 'All' ? <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{`${decrypt(quote.device.name)}`} - {`${quote.device.ID}`}</text>
              </div> : <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{`${quote.device}`}</text>
              </div>}
              <div style={{ display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                {!quote.full_time && <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{`${ret_double(quote.start.hr)}`} : {`${ret_double(quote.start.min)}`} {`${quote.start.type}`}</text>}
                {quote.full_time && <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>24 Hours</text>}

              </div>
              <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                {!quote.full_time && <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{`${ret_double(quote.end.hr)}`} : {`${ret_double(quote.end.min)}`} {`${quote.end.type}`}</text>}
                {quote.full_time && <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>24 Hours</text>}

              </div>
              <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center', wordBreak: 'break-all' }}>{quote.content.type != 'url' ? `${decrypt(quote.content.name)}` : quote.URL}</text>
              </div>
              <div onClick={(e) => { e.stopPropagation(); setEditSecond({ ...quote }); setSecond(quote.timing) }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.14 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>{`${quote.timing} s`} <text style={{ fontSize: 18 }}>{quote.content.type == 'image' ? '✍️' : null}</text></text>
              </div>
              <div onClick={(e) => { e.stopPropagation(); setDeleteContent(quote.ID) }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>{delete_icon}</text>
              </div>
            </div>
          </div>
        )}
      </Draggable> : <Draggable draggableId={quote.id} index={index}>
        {provided => (
          <div onClick={(e) => { setDeleteContent(quote.ID) }} style={{ height: 60, width: 0.94 * width, backgroundColor: 'white', display: 'flex', alignSelf: 'center', justifyContent: 'space-between', alignContent: 'center' }}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div onClick={(e) => { setDeleteContent(quote.ID) }} onMouseLeave={() => { setCursorImg(null); setCursorVid(null) }} onMouseEnter={() => { if (quote.content.type == 'image') { setCursorImg(quote.content.uri); setCursorVid(null) } else { setCursorVid(quote.content.uri); setCursorImg(null) } }} style={{ width: 0.94 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>
              <div style={{ display: 'flex', height: 56, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5, flexDirection: 'column' }}>
                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{today_dat(Number(quote.start_dat))}</text>
                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center', marginTop: 4 }}>{today_dat(Number(quote.end_dat))}</text>
              </div>
              {quote.device != 'All' ? <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${decrypt(quote.device.name)}`} - {`${quote.device.ID}`}</text>
              </div> : <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${quote.device}`}</text>
              </div>}
              <div style={{ display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                {!quote.full_time && <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${ret_double(quote.start.hr)}`} : {`${ret_double(quote.start.min)}`} {`${quote.start.type}`}</text>}
                {quote.full_time && <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>24 Hours</text>}

              </div>
              <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                {!quote.full_time && <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${ret_double(quote.end.hr)}`} : {`${ret_double(quote.end.min)}`} {`${quote.end.type}`}</text>}
                {quote.full_time && <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>24 Hours</text>}

              </div>
              <div style={{ display: 'flex', height: 56, width: 0.20 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5, wordBreak: 'break-all' }}>
                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{quote.content.type != 'url' ? `${decrypt(quote.content.name)}` : quote.URL}</text>
              </div>
              <div onClick={(e) => { e.stopPropagation(); setEditSecond({ ...quote }); setSecond(quote.timing) }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.16 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <text style={{ color: 'white', fontSize: 9, fontWeight: '600', textAlign: 'center' }}>{`${quote.timing} s`} <text style={{ fontSize: 18 }}>{quote.content.type == 'image' ? '✍️' : null}</text></text>
              </div>
              <div onClick={(e) => { e.stopPropagation(); setDeleteContent(quote.ID) }} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>{delete_icon}</text>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    );
  }

  const QuoteList = React.memo(function QuoteList({ quotes }) {
    return quotes.map((quote, index) => (
      <Quote quote={quote} index={index} key={quote.id} />
    ));
  });

  function onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const items = reorder(
      mainSetup,
      result.source.index,
      result.destination.index
    );

    setMainSetup([...items])
    updateSerial(items)
  }

  async function updateSerial(mains) {
    let arr = {};
    let obj = {}
    for (let i = 0; i < mains.length; i++) {
      arr[mains[i].ID] = mains[i]
      obj = arr[mains[i].ID]
      obj['index'] = i
      arr[mains[i].ID] = obj
    }

    await calendardb.child(String(key)).set(arr)
  }

  const grid = 8;

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "lightgreen" : "grey",

    // styles we need to apply on draggables
    ...draggableStyle
  });

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "#111417",
    padding: grid,
    width: 250
  });

  const [cursor_img, setCursorImg] = useState(null)
  const [cursor_vid, setCursorVid] = useState(null)


  const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
  ];

  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (selectedOption == null) {
      let temp = [...mainAll]
      setMainSetup([...temp])
    }
    else if (selectedOption != null) {
      let temp = [...mainAll]
      let arr = []
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].device.ID == selectedOption) {
          arr.push(temp[i])
        }
      }
      console.log('Array filter ', arr)
      setMainSetup([...arr])
    }
  }, [mainAll, selectedOption])

  console.log('selectedOption content ', selectedOption)

  const [time, setTime] = useState(Date.now())

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000 * 120)
    return () => {
      clearInterval(interval)
    }
  }, [])

  const [full_time, setFullTime] = useState(false)

  console.log('start ', start)
  console.log('Edit second ', edit_second)


  const [width, setwidth] = useState(window.innerWidth);
  const [height, setWindowHeight] = useState(2000);

  useEffect(() => {
    const windowSizeHandler = () => {
      setwidth(window.innerWidth)
      setWindowHeight(2000)
    };
    window.addEventListener("resize", windowSizeHandler);

    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  const isMobile = width <= 768;


  // ✅ you asked: wider drawer on mobile (0.80)
  const drawerW = isMobile ? width * 0.80 : width * 0.20;

  // ✅ 3) One-line titles in mobile drawer
  const mobileDrawerTitleStyle = (maxW) => ({
    color: "white",
    marginLeft: 18,
    fontWeight: "600",
    fontSize: 15,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: maxW,
    display: "block",
  });


  const [drawerOpen, setDrawerOpen] = useState(false);

  function handleOpenDrawerButton() {
    setDrawerOpen(!drawerOpen);
  }

  function handleBackdropClick() {
    setDrawerOpen(false);
  }


  let drawerClasses = drawerOpen ? "side-drawer open" : "side-drawer";

  function ImagePreviewCard({
    imageUrl,
    title = "Sale post",
    onClick,
  }) {
    const styles = {
      wrapper: {
        width: "100%",
        background: "#1F2A3A",
        borderRadius: 24,
        padding: 18,
        boxSizing: "border-box",
        cursor: onClick ? "pointer" : "default",
      },

      imageContainer: {
        width: "100%",
        height: 110,
        borderRadius: 18,
        overflow: "hidden",
        background: "#0B0F14",
      },

      image: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        display: "block",
      },

      title: {
        marginTop: 10,
        fontSize: 16,
        fontWeight: 500,
        color: "#9CA3AF",
      },
    };

    return (
      <div style={styles.wrapper} onClick={onClick}>
        <div style={styles.imageContainer}>
          <img
            src={imageUrl}
            alt={title}
            style={styles.image}
          />
        </div>

        <div style={styles.title}>{title}</div>
      </div>
    );
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (modal) {
      setFullTime(true)
    }
  }, [modal])

  const [showUrlInput, setShowUrlInput] = useState(false);
  const [urlValue, setUrlValue] = useState("");

  const resetAddContentModal = () => {
    setAiImage(false);
    setModal(false);
    setCurrContent(null);
    setCurrDevice(null);
    setStartDate(new Date().getTime());
    setEndDate(new Date().getTime());
    setTiming(0);
    setStart(null);
    setEnd(null);
    setShowUrlInput(false);
    setUrlValue("");
  };


  const premiumSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 52,
      backgroundColor: "#181C20",
      borderColor: state.isFocused ? "#3AB549" : "rgba(255,255,255,0.10)",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(58,181,73,0.18)" : "none",
      borderRadius: 14,
      color: "#fff",
      paddingLeft: 6,
      cursor: "pointer",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: "#3AB549",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#181C20",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: 14,
      overflow: "hidden",
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      paddingTop: 6,
      paddingBottom: 6,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "rgba(58,181,73,0.12)" : "#181C20",
      color: state.data?.isAddUrlOption ? "#3AB549" : "#fff",
      fontWeight: state.data?.isAddUrlOption ? 700 : 500,
      cursor: "pointer",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#fff",
      fontWeight: 500,
    }),
    placeholder: (base) => ({
      ...base,
      color: "rgba(255,255,255,0.45)",
      fontWeight: 500,
    }),
    input: (base) => ({
      ...base,
      color: "#fff",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? "#3AB549" : "rgba(255,255,255,0.55)",
      "&:hover": {
        color: "#3AB549",
      },
    }),
  };

  const labelStyle = {
    textAlign: "left",
    fontWeight: "500",
    fontSize: 14,
    color: "rgba(255,255,255,0.92)",
    marginBottom: 8,
  };

  const sectionWidth = 500;

  const handleContentChange = (e) => {
    if (!e) return;

    if (e.isAddUrlOption) {
      setShowUrlInput(true);
      setCurrContent(null);
      setCurrDuration(0);
      setTiming(0);
      return;
    }

    setShowUrlInput(false);
    setUrlValue("");
    setCurrContent({
      ID: e.ID,
      name: e.name,
      uri: e.uri,
      type: e.type,
    });

    if (e.duration !== undefined) {
      setTiming(float2int(e.duration));
      setCurrDuration(e.duration);
    } else {
      setTiming(0);
      setCurrDuration(0);
    }
  };

  const [showUrlField, setShowUrlField] = useState(false);
  const [urlInput, setUrlInput] = useState("");

  const contentOptions = [
    ...(Array.isArray(mycontent) ? mycontent : []),
    {
      ID: "__add_url__",
      name: "Add Url",
      label: "✦ Add Url",
      type: "url_option",
      isAddUrl: true,
    },
  ];

  return (
    !isMobile ? <div style={{ position: 'relative', backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>

      <div style={{ backgroundColor: '#080A0C', position: 'absolute', top: 0, left: 0, display: 'flex', flexDirection: 'column', height: height, width: width * 0.20, textAlign: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: width * 0.20, height: 100, justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={logo}
            alt="Logo"
            style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
          />
        </div>


        {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

          <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Welcome</text>
            <div style={{ height: 41, width: 20 }} />
          </div>
        </div> : null}

        <div onClick={() => navigate('/Devices')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

          <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Devices</text>
            <div style={{ height: 41, width: 20 }} />
          </div>
        </div>

        <div onClick={() => navigate('/Content')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

          <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Content</text>
            <div style={{ height: 41, width: 20 }} />
          </div>
        </div>

        <div style={{ marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
          <div style={{ backgroundColor: '#181E25', width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Calendar</text>
            <img src={require('../assets/right.png')} style={{ height: 41, width: 20 }} />
          </div>
        </div>

        <div
          onClick={() => setAiOpen(!aiOpen)}
          style={{
            cursor: "pointer",
            marginTop: 5,
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            width: 0.18 * width,
            padding: 10,
            alignSelf: "center",
            alignItems: "center",
            height: 52,
          }}
        >
          <div
            style={{
              width: 0.14 * width,
              flexDirection: "row",
              display: "flex",
              padding: 10,
              borderRadius: 6,
              height: 52,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <text style={{ color: "white", marginLeft: 30, fontWeight: "600", fontSize: 16 }}>
              AI Generator
            </text>

            <img
              src={require("../assets/right.png")}
              style={{
                height: 41,
                width: 20,
                transform: aiOpen ? "rotate(90deg)" : "rotate(0deg)",
                transition: "transform 200ms ease",
              }}
            />
          </div>
        </div>

        <Collapse isOpened={aiOpen}>
          <AiLeftSubMenuDesktop />
        </Collapse>

        <div onClick={() => navigate('/Subscription')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
          <div style={{ position: 'relative', width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Subscription</text>
            <div style={{ height: 41, width: 20 }} />
            {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
              <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
            </div>}
            {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
              <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
            </div>}
            <div>
            </div>
          </div>
        </div>

        <div onClick={() => navigate('/Settings')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

          <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Settings</text>
            <div style={{ height: 41, width: 20 }} />
          </div>
        </div>

      </div>


      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: width * 0.20, width: width * 0.80, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

        <div style={{ display: 'flex', height: 100, width: width * 0.7991, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (0.74 * width) - 105 }}>
            <text style={{ marginLeft: 0, fontSize: 24, fontWeight: '700', letterSpacing: 1.01, color: 'white', textAlign: 'center' }}>Content</text>

            {/*
            <div style={{ marginLeft: 6, marginTop: 4 }}>
              <stripe-buy-button
                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
              >
              </stripe-buy-button>
            </div>
            */}

          </div>

          <div onClick={() => {
            navigate('/');
            localStorage.removeItem('display')
            localStorage.removeItem('devices')
            SetId(null)
          }} style={{ cursor: 'pointer', alignSelf: 'center', width: 105, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
            <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
          </div>

        </div>

        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width * 0.80, height: height - 100, alignItems: 'center' }}>


          <div style={{ width: 0.74 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 8 }}>


            <div style={{ width: 0.73 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

              <div style={{ width: 0.17 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>


                <div style={{ display: 'flex', flexDirection: 'column', width: 302, justifyContent: 'center', alignContent: 'center', height: 45, backgroundColor: 'transparent', marginTop: 10, marginLeft: -5 }}>
                  <Select
                    placeholder='Select Device'
                    defaultValue={selectedOption}
                    isClearable={true}
                    onChange={(e) => {
                      if (e != null) { setSelectedOption(e.device) }
                      else { setSelectedOption(null) }
                    }}
                    options={devices}
                    className="basic-single"
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        textAlign: "left",
                        fontWeight: '500',
                        minHeight: 36,
                        height: 43,
                        backgroundColor: '#ECFEFD',
                        borderStyle: 'none',
                        fontFamily: 'Poppins', color: 'black', fontWeight: '500', fontSize: 14,
                        borderRadius: 6,
                        boxShadow: 'none'
                      })
                    }}
                    maxMenuHeight={200}
                    menuPlacement='auto'
                    menuShouldScrollIntoView={true}
                  />
                </div>


              </div>

              <div style={{ width: 0.21 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', alignSelf: 'center', }}>


                <div onClick={() => setModal(true)} style={{ cursor: 'pointer', display: 'flex', width: 220, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                  {add_icon}
                  <text style={{ fontWeight: '600', fontSize: 18, color: 'black', marginLeft: 6 }}>Add content to device</text>
                </div>

              </div>

            </div>
          </div>











          <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>


            <div style={{ display: 'flex', height: 51, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.08 * width, justifyContent: 'flex-start', alignItems: 'center', borderRadius: 5 }}>


                <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Date</text>
              </div>
            </div>
            <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.09 * width, justifyContent: 'flex-start', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Device</text>
              </div>
            </div>

            <div style={{ display: 'flex', height: 51, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.05 * width, justifyContent: 'flex-start', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Time From</text>
              </div>
            </div>

            <div style={{ display: 'flex', height: 51, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.04 * width, justifyContent: 'flex-start', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Until</text>
              </div>
            </div>


            <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.09 * width, justifyContent: 'flex-start', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Content</text>
              </div>
            </div>


            <div style={{ display: 'flex', height: 51, width: 0.14 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.14 * width, justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 17, fontWeight: '600', textAlign: 'center' }}>Timing of content in seconds</text>
              </div>
            </div>



            <div style={{ display: 'flex', height: 51, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.05 * width, justifyContent: 'flex-start', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 18, fontWeight: '600', textAlign: 'center' }}>Delete</text>
              </div>
            </div>
          </div>

          {
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="list">
                {provided => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    <QuoteList quotes={mainSetup} />
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          }

        </div>

      </div>

      <input id="actual" ref={ref} accept="image/*" onChange={onChangePicture} type="file" hidden={true} />
      <input id="actual" ref={ref1} accept="video/*" onChange={onChangePicture} type="file" hidden={true} />


      {!isMobile && <ReactModal
        style={{
          overlay: {
            backgroundColor: "rgba(0,0,0,0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          },
          content: {
            position: "relative",
            inset: "unset",
            width: "640px",
            maxWidth: "92vw",
            height: "auto",
            maxHeight: "90vh",
            backgroundColor: "#111417",
            borderRadius: 12,
            padding: 0,
            overflowY: "auto",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
          }

        }} isOpen={modal}
        onRequestClose={() => {
          setAiImage(false);
          setModal(false);
          setCurrContent(null);
          setCurrDevice(null);
          setStartDate(new Date().getTime());
          setEndDate(new Date().getTime());
          setTiming(0);
          setStart(null);
          setEnd(null);
          setShowUrlField(false);
          setUrlInput(""); window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417', alignSelf: 'center', paddingBottom: 20 }}>   <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '90%', alignSelf: 'center' }}>
          <text></text>
          <IoIosCloseCircle onClick={() => { setModal(false); setCurrContent(null); setCurrDevice(null); setStartDate(new Date().getTime()); setEndDate(new Date().getTime()); setTiming(0); setStart(null); setEnd(null) }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={34} />
        </div>
          <div style={{ display: 'flex', flexDirection: 'column', width: '65%', justifyContent: 'center', alignContent: 'center' }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24 }}>Add new content to device</text></div>


            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: 470, marginTop: 5, alignSelf: 'center' }}>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 225, marginTop: 5, alignSelf: 'center' }}>


                <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: 'white' }}>Start date</text>
                <div style={{ display: 'flex', width: 225, marginTop: 5 }}>
                  <DatePicker
                    // ref={ref}
                    customInput={<DateInput1 />}
                    selected={startDate}
                    required
                    onChange={(date) => { setStartDate(date.getTime()) }}
                  />
                </div>

              </div>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: 225, marginTop: 5, alignSelf: 'flex-end', marginLeft: 5 }}>


                <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: 'white' }}>End date</text>
                <div style={{ display: 'flex', width: 225, marginTop: 5 }}>
                  <DatePicker
                    // ref={ref}
                    customInput={<DateInput2 />}
                    selected={endDate}
                    required
                    onChange={(date) => { setEndDate(date.getTime()) }}
                  />
                </div>

              </div>

            </div>


            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 470, marginTop: 10, alignSelf: 'center' }}>
              <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: curr_device == null ? 'red' : 'white' }}>Select your device</text>
              <div style={{ display: 'flex', width: 470, marginTop: 5 }}>
                <Select
                  onChange={(e) => { if (e.label != 'All') setCurrDevice({ ID: e.device, name: e.name }); else { setCurrDevice('All') } }}
                  options={devices}
                  placeholder={'Select device'}
                  className="basic-single"
                  classNamePrefix="select"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      textAlign: "left",
                      fontWeight: '400', fontSize: 15,
                    })
                  }}
                  maxMenuHeight={120}
                  menuShouldScrollIntoView={true}
                />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 470, marginTop: 5, alignSelf: 'center' }}>
              <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: (curr_content == null && !showUrlField) ? 'red' : 'white' }}>
                Select your content
              </text>

              <div style={{ display: 'flex', width: 470, marginTop: 10 }}>
                <Select
                  onChange={(e) => {
                    if (e.ID === "__add_url__") {
                      setShowUrlField(true);
                      setUrlInput("");
                      setCurrContent({
                        ID: "__add_url__",
                        name: "Add Url",
                        uri: "",
                        type: "url",
                      });
                      setTiming(0);
                      setCurrDuration(0);
                    } else {
                      setShowUrlField(false);
                      setUrlInput("");
                      setCurrContent({
                        ID: e.ID,
                        name: e.name,
                        uri: e.uri,
                        type: e.type,
                      });

                      if (e.duration != undefined) {
                        setTiming(float2int(e.duration));
                        setCurrDuration(e.duration);
                      } else {
                        setTiming(0);
                        setCurrDuration(0);
                      }
                    }
                  }}
                  options={contentOptions}
                  placeholder={'Select content'}
                  className="basic-single"
                  classNamePrefix="select"
                  getOptionLabel={(option) => {
                    if (option.ID === "__add_url__") return option.label;
                    return option.name ? decrypt(option.name) : "";
                  }}
                  getOptionValue={(option) => String(option.ID)}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      textAlign: "left",
                      fontWeight: '400',
                      fontSize: 15,
                      minHeight: 42,
                    }),
                    menu: (base) => ({
                      ...base,
                      backgroundColor: '#ffffff',
                      zIndex: 9999,
                    }),
                    menuList: (base) => ({
                      ...base,
                      backgroundColor: '#ffffff',
                    }),
                    option: (base, state) => ({
                      ...base,
                      color: state.data?.isAddUrl ? '#3AB549' : '#111417',
                      fontWeight: state.data?.isAddUrl ? '700' : '400',
                      backgroundColor: state.isSelected
                        ? 'rgba(58,181,73,0.12)'
                        : state.isFocused
                          ? '#f3f5f7'
                          : '#ffffff',
                      borderLeft: state.data?.isAddUrl ? '3px solid #3AB549' : '3px solid transparent',
                      cursor: 'pointer',
                    }),
                    singleValue: (base, state) => ({
                      ...base,
                      color: state.data?.isAddUrl ? '#3AB549' : '#111417',
                      fontWeight: state.data?.isAddUrl ? '700' : '400',
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: '#7a7f87',
                    }),
                    input: (base) => ({
                      ...base,
                      color: '#111417',
                    }),
                  }}
                  maxMenuHeight={150}
                  menuShouldScrollIntoView={true}
                  menuPlacement='top'
                />
              </div>

              {showUrlField && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    width: 470,
                    marginTop: 10,
                    alignSelf: 'center',
                    backgroundColor: '#161B20',
                    border: '1px solid rgba(58,181,73,0.35)',
                    borderRadius: 8,
                    padding: 10,
                    boxSizing: 'border-box',
                  }}
                >
                  <text
                    style={{
                      textAlign: 'left',
                      fontWeight: '600',
                      fontSize: 14,
                      color: '#3AB549',
                      marginBottom: 6,
                    }}
                  >
                    External Url
                  </text>

                  <input
                    type="text"
                    value={urlInput}
                    onChange={(e) => setUrlInput(e.target.value)}
                    placeholder="https://example.com"
                    style={{
                      width: '100%',
                      height: 42,
                      borderRadius: 6,
                      border: '1px solid #3a3f45',
                      backgroundColor: '#1a1f24',
                      color: 'white',
                      paddingLeft: 10,
                      paddingRight: 10,
                      outline: 'none',
                      fontSize: 14,
                      boxSizing: 'border-box',
                    }}
                  />

                  <text
                    style={{
                      marginTop: 6,
                      fontSize: 11,
                      color: 'rgba(255,255,255,0.65)',
                      textAlign: 'left',
                    }}
                  >
                    Please enter a full link starting with https://
                  </text>
                </div>
              )}

              {curr_content != null && !showUrlField ? (
                <ImagePreviewCard imageUrl={curr_content.uri} title={decrypt(curr_content.name)} />
              ) : null}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 470, marginTop: 5, alignSelf: 'center', opacity: curr_duration == 0 ? 1 : 0.7 }}>
              <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: 'white' }}>Timing of content <text style={{ color: 'white', fontSize: 12, fontWeight: '600' }}>{curr_duration != 0 ? `- Current Video length ${float2int(curr_duration)} s` : null}</text> </text>
              <div style={{ display: 'flex', width: 470, marginTop: 5 }}>
                <Select
                  onChange={(e) => { setTiming(e.sec) }}
                  options={seconds}
                  isDisabled={curr_duration != 0}
                  placeholder={timing == 0 ? 'Select timing' : timing + " s"}
                  className="basic-single"
                  classNamePrefix="select"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      textAlign: "left",
                      fontWeight: '400', fontSize: 15,
                    })
                  }}
                  maxMenuHeight={120}
                  menuShouldScrollIntoView={true}
                />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: 470, marginTop: 5, alignSelf: 'center' }}>
              {full_time ? <FaRegCheckSquare onClick={() => { setFullTime(!full_time) }} color='white' size={20} /> : <MdCheckBoxOutlineBlank onClick={() => { setFullTime(!full_time) }} color='white' size={20} />}
              <text style={{ color: 'white', fontWeight: '400', fontSize: 15, marginLeft: 5 }}>24 Hours</text>
            </div>

            <div style={{ opacity: full_time ? 0.5 : 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: 470, marginTop: 5, alignSelf: 'center' }}>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 225, marginTop: 5, alignSelf: 'center' }}>


                <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: (((start != null && start.type != undefined) || full_time) ? 'white' : 'red') }}>Time from</text>
                <div style={{ display: 'flex', width: 224, marginTop: 5, alignItems: 'center', flexDirection: 'row', justifyContent: 'space-around' }}>
                  <div style={{ display: 'flex', width: 120 }}>
                    <Select
                      onChange={(e) => { setStart({ ...start, hr: e.hour, min: e.min }) }}
                      options={times}
                      placeholder={'3 : 20'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400', fontSize: 15,
                        })
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement='top'
                      isDisabled={full_time}
                    />
                  </div>
                  <div style={{ display: 'flex', width: 100 }}>
                    <Select
                      onChange={(e) => { setStart({ ...start, type: e.label }) }}
                      options={[{ label: 'AM', value: 'AM' }, { label: 'PM', value: 'PM' }]}
                      placeholder={'AM/PM'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400', fontSize: 15,
                        })
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement='top'
                      isDisabled={full_time}
                    />
                  </div>
                </div>

              </div>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: 225, marginTop: 5, alignSelf: 'flex-end', marginLeft: 5 }}>


                <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: (((end != null && end.type != undefined) || full_time) ? 'white' : 'red') }}>Until</text>

                <div style={{ display: 'flex', width: 224, marginTop: 5, alignItems: 'center', flexDirection: 'row', justifyContent: 'space-around' }}>

                  <div style={{ display: 'flex', width: 120 }}>
                    <Select
                      onChange={(e) => { setEnd({ ...end, hr: e.hour, min: e.min }) }}
                      options={times}
                      placeholder={'4 : 20'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400', fontSize: 15,
                        })
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement='top'
                      isDisabled={full_time}
                    />
                  </div>

                  <div style={{ display: 'flex', width: 100 }}>
                    <Select
                      onChange={(e) => { setEnd({ ...end, type: e.label }) }}
                      options={[{ label: 'AM', value: 'AM' }, { label: 'PM', value: 'PM' }]}
                      placeholder={'AM/PM'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400', fontSize: 15,
                        })
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement='top'
                      isDisabled={full_time}
                    />
                  </div>

                </div>


              </div>

            </div>

            <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => add_to_calendar()} style={{ marginBottom: 2, height: 53, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 190, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'white', fontWeight: 'bold', fontSize: 17 }}>Submit</text> </div>
          </div>
        </div>
      </ReactModal>}



      {cursor_img ? <img src={cursor_img} style={{ objectFit: 'contain', position: 'absolute', top: 400, left: 5, height: 250, width: (0.20 * width) - 10 }} /> : null}
      {cursor_vid ? <video autoPlay src={cursor_vid} style={{ objectFit: 'contain', position: 'absolute', top: 400, left: 5, height: 250, width: (0.20 * width) - 10 }} /> : null}

      <ReactModal
        style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', bottom: '50%' }, content: { display: 'flex', position: 'absolute', top: '5%', left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 300, justifyContent: 'center', zIndex: 10000 } }}
        isOpen={delete_content != false}
        onRequestClose={() => { setDeleteContent(false) }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417', zIndex: 60000 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '89%', alignSelf: 'center' }}>
            <text></text>
            <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={34} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 25 }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>Are you sure to delete this content ?</text></div>

            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 20, cursor: 'pointer' }}>
              <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 53, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'white', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
              <div onClick={() => setDeleteContent(false)} style={{ height: 53, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 10 }}>
                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>



      {edit_second != null && <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417', width: 490, height: 410, position: 'fixed', top: '20%', alignSelf: 'center', borderWidth: 1, borderColor: 'white', borderStyle: 'solid', left: (width - 490) / 2 }}>

        <IoIosCloseCircle onClick={() => { setEditSecond(null); setSecond(0); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

        <div style={{ display: 'flex', flexDirection: 'column', width: 400, justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
          <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Update Content timing</text></div>

          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 400, marginTop: 15, alignSelf: 'center', opacity: curr_duration == 0 ? 1 : 0.7 }}>
            <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: 'white' }}>Timing of content <text style={{ color: 'white', fontSize: 12, fontWeight: '600' }}>{curr_duration != 0 ? `- Current Video length ${float2int(curr_duration)} s` : null}</text> </text>
            <div style={{ display: 'flex', width: 400, marginTop: 5 }}>
              <Select
                onChange={(e) => { setSecond(e.sec) }}
                options={seconds}
                placeholder={second + " s"}
                className="basic-single"
                classNamePrefix="select"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    textAlign: "left",
                    fontWeight: '400', fontSize: 15,
                  })
                }}
                maxMenuHeight={120}
                menuShouldScrollIntoView={true}
              />
            </div>
          </div>

          <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => { updateTiming() }} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Update</text> </div>
        </div>
      </div>}






      <wc-toast></wc-toast>

    </div> : <div style={{ position: 'relative', backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0, overflowX: 'hidden' }}>

      <div className={drawerClasses} style={{ width: drawerW }}>

        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: drawerW, height: 60, justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={logo}
            alt="Logo"
            style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
          />
        </div>

        {/* CONTENT */}
        {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 10, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Welcome</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div> : null}

        {/* DEVICES */}
        <div onClick={() => navigate('/Devices')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Devices</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div>


        {/* CONTENT */}
        <div onClick={() => navigate('/Content')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Content</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div>

        <div style={{ marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW - 30, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30 }}>
          <div style={{ backgroundColor: '#181E25', width: drawerW - 42, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 32) - 46)}>Calendar</text>
            <img src={require('../assets/right.png')} style={{ height: 30, width: 20 }} />
          </div>
        </div>

        <div onClick={() => navigate('/AIGenerator')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>AI Generator</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div>

        {/* SUBSCRIPTION */}
        <div onClick={() => navigate('/Subscription')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ position: 'relative', width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Subscription</text>
            <div style={{ height: 30, width: 20 }} />
            {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
              <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
            </div>}
            {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
              <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
            </div>}
          </div>
        </div>


        {/* SETTINGS */}
        <div onClick={() => navigate('/Settings')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Settings</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div>

        <div onClick={() => {
          navigate('/')
          localStorage.removeItem('display')
          localStorage.removeItem('devices')
          SetId(null)
        }} style={{ left: ((0.35 * width) - 100) / 2, position: 'absolute', bottom: 10, alignContent: 'center', cursor: 'pointer', alignSelf: 'center', width: 150, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
          <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
        </div>


      </div>

      {drawerOpen && <BackDrop closeDrawer={handleBackdropClick} />}



      <div style={{ display: 'flex', flexDirection: 'column', width: width, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

        <div style={{ display: 'flex', height: 100, width: width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (width * 0.94) - 5 }}>
            <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <VscThreeBars size={30} color='white' onClick={handleOpenDrawerButton} />
            </div>
            <div style={{ marginLeft: 6, marginTop: 4 }}>
              <stripe-buy-button
                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
              >
              </stripe-buy-button>
            </div>


          </div>


        </div>

        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width, height: height - 100, alignItems: 'center' }}>


          <div style={{ width: 0.94 * width, height: 115, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 8 }}>


            <div style={{ width: 0.93 * width, height: 115, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-around', alignSelf: 'center', }}>

              <div style={{ width: (0.93 * width * 90) / 100, height: 45, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', alignSelf: 'center', marginTop: 4 }}>

                <Select
                  placeholder='Select Device'
                  defaultValue={selectedOption}
                  isClearable={true}
                  onChange={(e) => {
                    if (e != null) { setSelectedOption(e.device) }
                    else { setSelectedOption(null) }
                  }}
                  options={devices}
                  className="basic-single2"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      textAlign: "left",
                      fontWeight: '500',
                      minHeight: 36,
                      height: 43,
                      backgroundColor: '#ECFEFD',
                      borderStyle: 'none',
                      fontFamily: 'Poppins', color: 'black', fontWeight: '500', fontSize: 14,
                      borderRadius: 6,
                      boxShadow: 'none'
                    })
                  }}
                  maxMenuHeight={200}
                  menuPlacement='auto'
                  menuShouldScrollIntoView={true}
                />


              </div>


              <div onClick={() => setModal(true)} style={{ cursor: 'pointer', display: 'flex', width: '90%', height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                {add_icon}
                <text style={{ fontWeight: '600', fontSize: 12, color: 'black', marginLeft: 6 }}>Add content to device</text>
              </div>


            </div>
          </div>


          <div style={{ width: 0.94 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 15 }}>


            <div style={{ display: 'flex', height: 51, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>


                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>Date</text>
              </div>
            </div>
            <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.09 * width, justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>Device</text>
              </div>
            </div>

            <div style={{ display: 'flex', height: 51, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.05 * width, justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>Time From</text>
              </div>
            </div>

            <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.04 * width, justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>Until</text>
              </div>
            </div>


            <div style={{ display: 'flex', height: 51, width: 0.20 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.09 * width, justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>Content</text>
              </div>
            </div>


            <div style={{ display: 'flex', height: 51, width: 0.16 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.14 * width, justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>Timing of content in seconds</text>
              </div>
            </div>



            <div style={{ display: 'flex', height: 51, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.05 * width, justifyContent: 'center', alignItems: 'center', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 11, fontWeight: '600', textAlign: 'center' }}>Delete</text>
              </div>
            </div>
          </div>

          {
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="list">
                {provided => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    <QuoteList quotes={mainSetup} />
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          }

        </div>

      </div>

      <input id="actual" ref={ref} accept="image/*" onChange={onChangePicture} type="file" hidden={true} />
      <input id="actual" ref={ref1} accept="video/*" onChange={onChangePicture} type="file" hidden={true} />


      {!isMobile && <ReactModal
        style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', bottom: '70%' }, content: { display: 'flex', position: 'absolute', top: '5%', left: '25%', display: 'flex', backgroundColor: '#111417', width: '50%', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 530, justifyContent: 'center' } }}
        isOpen={modal}
        onRequestClose={() => {
          setModal(false); setCurrContent(null); setCurrDevice(null); setStartDate(new Date().getTime()); setEndDate(new Date().getTime()); setTiming(0); setStart(null); setEnd(null); window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417', alignSelf: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '90%', alignSelf: 'center' }}>
            <text></text>
            <IoIosCloseCircle onClick={() => { setModal(false); setCurrContent(null); setCurrDevice(null); setStartDate(new Date().getTime()); setEndDate(new Date().getTime()); setTiming(0); setStart(null); setEnd(null) }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={34} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', width: '65%', justifyContent: 'center', alignContent: 'center' }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24 }}>Add new content to device</text></div>


            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: 470, marginTop: 5, alignSelf: 'center' }}>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 225, marginTop: 5, alignSelf: 'center' }}>


                <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: 'white' }}>Start date</text>
                <div style={{ display: 'flex', width: 225, marginTop: 5 }}>
                  <DatePicker
                    // ref={ref}
                    customInput={<DateInput1 />}
                    selected={startDate}
                    required
                    onChange={(date) => { setStartDate(date.getTime()) }}
                  />
                </div>

              </div>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: 225, marginTop: 5, alignSelf: 'flex-end', marginLeft: 5 }}>


                <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: 'white' }}>End date</text>
                <div style={{ display: 'flex', width: 225, marginTop: 5 }}>
                  <DatePicker
                    // ref={ref}
                    customInput={<DateInput2 />}
                    selected={endDate}
                    required
                    onChange={(date) => { setEndDate(date.getTime()) }}
                  />
                </div>

              </div>

            </div>


            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 470, marginTop: 10, alignSelf: 'center' }}>
              <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: curr_device == null ? 'red' : 'white' }}>Select your device</text>
              <div style={{ display: 'flex', width: 470, marginTop: 5 }}>
                <Select
                  onChange={(e) => { if (e.label != 'All') setCurrDevice({ ID: e.device, name: e.name }); else { setCurrDevice('All') } }}
                  options={devices}
                  placeholder={'Select device'}
                  className="basic-single"
                  classNamePrefix="select"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      textAlign: "left",
                      fontWeight: '400', fontSize: 15,
                    })
                  }}
                  maxMenuHeight={120}
                  menuShouldScrollIntoView={true}
                />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 470, marginTop: 5, alignSelf: 'center' }}>
              <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: curr_content == null ? 'red' : 'white' }}>Select your content</text>
              <div style={{ display: 'flex', width: 470, marginTop: 10 }}>
                <Select
                  onChange={(e) => { setCurrContent({ ID: e.ID, name: e.name, uri: e.uri, type: e.type }); if (e.duration != undefined) { setTiming(float2int(e.duration)); setCurrDuration(e.duration) } else { setTiming(0); setCurrDuration(0) } }}
                  options={mycontent}
                  placeholder={'Select content'}
                  className="basic-single"
                  classNamePrefix="select"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      textAlign: "left",
                      fontWeight: '400', fontSize: 15,
                    })
                  }}
                  maxMenuHeight={120}
                  menuShouldScrollIntoView={true}
                />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 470, marginTop: 5, alignSelf: 'center', opacity: curr_duration == 0 ? 1 : 0.7 }}>
              <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: 'white' }}>Timing of content <text style={{ color: 'white', fontSize: 12, fontWeight: '600' }}>{curr_duration != 0 ? `- Current Video length ${float2int(curr_duration)} s` : null}</text> </text>
              <div style={{ display: 'flex', width: 470, marginTop: 5 }}>
                <Select
                  onChange={(e) => { setTiming(e.sec) }}
                  options={seconds}
                  isDisabled={curr_duration != 0}
                  placeholder={timing == 0 ? 'Select timing' : timing + " s"}
                  className="basic-single"
                  classNamePrefix="select"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      textAlign: "left",
                      fontWeight: '400', fontSize: 15,
                    })
                  }}
                  maxMenuHeight={120}
                  menuShouldScrollIntoView={true}
                />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: 470, marginTop: 5, alignSelf: 'center' }}>
              {full_time ? <FaRegCheckSquare onClick={() => { setFullTime(!full_time) }} color='white' size={20} /> : <MdCheckBoxOutlineBlank onClick={() => { setFullTime(!full_time) }} color='white' size={20} />}
              <text style={{ color: 'white', fontWeight: '400', fontSize: 15, marginLeft: 5 }}>24 Hours</text>
            </div>

            <div style={{ opacity: full_time ? 0.5 : 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: 470, marginTop: 5, alignSelf: 'center' }}>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 225, marginTop: 5, alignSelf: 'center' }}>


                <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: (((start != null && start.type != undefined) || full_time) ? 'white' : 'red') }}>Time from</text>
                <div style={{ display: 'flex', width: 224, marginTop: 5, alignItems: 'center', flexDirection: 'row', justifyContent: 'space-around' }}>
                  <div style={{ display: 'flex', width: 120 }}>
                    <Select
                      onChange={(e) => { setStart({ ...start, hr: e.hour, min: e.min }) }}
                      options={times}
                      placeholder={'3 : 20'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400', fontSize: 15,
                        })
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement='top'
                      isDisabled={full_time}
                    />
                  </div>
                  <div style={{ display: 'flex', width: 100 }}>
                    <Select
                      onChange={(e) => { setStart({ ...start, type: e.label }) }}
                      options={[{ label: 'AM', value: 'AM' }, { label: 'PM', value: 'PM' }]}
                      placeholder={'AM/PM'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400', fontSize: 15,
                        })
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement='top'
                      isDisabled={full_time}
                    />
                  </div>
                </div>

              </div>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: 225, marginTop: 5, alignSelf: 'flex-end', marginLeft: 5 }}>


                <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: (((end != null && end.type != undefined) || full_time) ? 'white' : 'red') }}>Until</text>

                <div style={{ display: 'flex', width: 224, marginTop: 5, alignItems: 'center', flexDirection: 'row', justifyContent: 'space-around' }}>

                  <div style={{ display: 'flex', width: 120 }}>
                    <Select
                      onChange={(e) => { setEnd({ ...end, hr: e.hour, min: e.min }) }}
                      options={times}
                      placeholder={'4 : 20'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400', fontSize: 15,
                        })
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement='top'
                      isDisabled={full_time}
                    />
                  </div>

                  <div style={{ display: 'flex', width: 100 }}>
                    <Select
                      onChange={(e) => { setEnd({ ...end, type: e.label }) }}
                      options={[{ label: 'AM', value: 'AM' }, { label: 'PM', value: 'PM' }]}
                      placeholder={'AM/PM'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400', fontSize: 15,
                        })
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement='top'
                      isDisabled={full_time}
                    />
                  </div>

                </div>


              </div>

            </div>

            <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => add_to_calendar()} style={{ height: 53, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 190, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'white', fontWeight: 'bold', fontSize: 17 }}>Submit</text> </div>
          </div>
        </div>
      </ReactModal>}


      {isMobile && modal && (
        <div
          style={{
            boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)',
            display: 'flex',
            flexDirection: 'column',
            width: 350,
            maxWidth: '94vw',
            justifyContent: 'flex-start',
            alignItems: 'center',
            alignContent: 'center',
            marginTop: 20,
            position: 'absolute',
            top: 50,
            left: (width - 350) / 2,
            backgroundColor: '#111417',
            alignSelf: 'center',
            borderRadius: 8,
            minHeight: 520,
            maxHeight: '85vh',
            borderWidth: 2,
            borderColor: 'white',
            borderStyle: 'solid',
            overflowY: 'auto',
            overflowX: 'hidden',
            paddingBottom: 20,
            zIndex: 999,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '97%',
              justifyContent: 'flex-start',
              alignItems: 'center',
              alignContent: 'center',
              backgroundColor: '#111417',
              alignSelf: 'center',
              flexWrap: 'wrap',
              paddingBottom: 20,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '90%',
                alignSelf: 'center',
                minHeight: 55,
                position: 'relative',
              }}
            >
              <text></text>
              <IoIosCloseCircle
                onClick={() => {
                  setModal(false);
                  setCurrContent(null);
                  setCurrDevice(null);
                  setStartDate(new Date().getTime());
                  setEndDate(new Date().getTime());
                  setTiming(0);
                  setStart(null);
                  setEnd(null);
                  setShowUrlField(false);
                  setUrlInput("");
                }}
                style={{ cursor: 'pointer', position: 'absolute', top: 12, right: 0 }}
                color="white"
                size={34}
              />
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '95%',
                justifyContent: 'flex-start',
                alignContent: 'center',
                paddingBottom: 20,
              }}
            >
              <div
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignContent: 'center',
                  alignSelf: 'center',
                  marginTop: 5,
                }}
              >
                <text
                  style={{
                    textAlign: 'center',
                    color: 'white',
                    fontWeight: '600',
                    fontSize: 14,
                  }}
                >
                  Add new content to devices
                </text>
              </div>

              <div
                style={{
                  display: 'flex',
                  minHeight: 40,
                  flexDirection: 'row',
                  justifyContent: 'center',
                  width: 290,
                  marginTop: 5,
                  alignSelf: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    width: 225,
                    marginTop: 5,
                    alignSelf: 'center',
                  }}
                >
                  <text
                    style={{
                      textAlign: 'left',
                      fontWeight: '400',
                      fontSize: 15,
                      color: 'white',
                    }}
                  >
                    Start date
                  </text>
                  <div style={{ display: 'flex', width: 225, marginTop: 5 }}>
                    <DatePicker
                      customInput={<DateInput1 />}
                      selected={startDate}
                      required
                      onChange={(date) => {
                        setStartDate(date.getTime());
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  width: 290,
                  marginTop: 5,
                  alignSelf: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    width: 225,
                    marginTop: 5,
                    alignSelf: 'center',
                  }}
                >
                  <text
                    style={{
                      textAlign: 'left',
                      fontWeight: '400',
                      fontSize: 15,
                      color: 'white',
                    }}
                  >
                    End date
                  </text>
                  <div style={{ display: 'flex', width: 225, marginTop: 5 }}>
                    <DatePicker
                      customInput={<DateInput2 />}
                      selected={endDate}
                      required
                      onChange={(date) => {
                        setEndDate(date.getTime());
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: 225,
                  marginTop: 10,
                  alignSelf: 'center',
                }}
              >
                <text
                  style={{
                    textAlign: 'left',
                    fontWeight: '400',
                    fontSize: 15,
                    color: curr_device == null ? 'red' : 'white',
                  }}
                >
                  Select your device
                </text>
                <div style={{ display: 'flex', width: 225, marginTop: 5, alignSelf: 'center' }}>
                  <Select
                    onChange={(e) => {
                      if (e.label != 'All') {
                        setCurrDevice({ ID: e.device, name: e.name });
                      } else {
                        setCurrDevice('All');
                      }
                    }}
                    options={devices}
                    placeholder={'Select device'}
                    className="basic-single2"
                    classNamePrefix="select"
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        textAlign: "left",
                        fontWeight: '400',
                        fontSize: 15,
                      }),
                    }}
                    maxMenuHeight={120}
                    menuShouldScrollIntoView={true}
                  />
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: 225,
                  marginTop: 2,
                  alignSelf: 'center',
                }}
              >
                <text
                  style={{
                    textAlign: 'left',
                    fontWeight: '400',
                    fontSize: 15,
                    color: curr_content == null && !showUrlField ? 'red' : 'white',
                  }}
                >
                  Select your content
                </text>

                <div style={{ display: 'flex', width: 225, marginTop: 7 }}>
                  <Select
                    onChange={(e) => {
                      if (e.ID === "__add_url__") {
                        setShowUrlField(true);
                        setUrlInput("");
                        setCurrContent({
                          ID: "__add_url__",
                          name: "Add Url",
                          uri: "",
                          type: "url",
                        });
                        setTiming(0);
                        setCurrDuration(0);
                      } else {
                        setShowUrlField(false);
                        setUrlInput("");
                        setCurrContent({
                          ID: e.ID,
                          name: e.name,
                          uri: e.uri,
                          type: e.type,
                        });

                        if (e.duration != undefined) {
                          setTiming(float2int(e.duration));
                          setCurrDuration(e.duration);
                        } else {
                          setTiming(0);
                          setCurrDuration(0);
                        }
                      }
                    }}
                    options={contentOptions}
                    placeholder={'Select content'}
                    className="basic-single"
                    classNamePrefix="select"
                    getOptionLabel={(option) => {
                      if (option.ID === "__add_url__") return option.label || "✦ Add Url";
                      return option.name ? decrypt(option.name) : "";
                    }}
                    getOptionValue={(option) => String(option.ID)}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        textAlign: "left",
                        fontWeight: '400',
                        fontSize: 15,
                        minHeight: 42,
                      }),
                      menu: (base) => ({
                        ...base,
                        backgroundColor: '#ffffff',
                        zIndex: 9999,
                      }),
                      menuList: (base) => ({
                        ...base,
                        backgroundColor: '#ffffff',
                      }),
                      option: (base, state) => ({
                        ...base,
                        color: state.data?.isAddUrl ? '#3AB549' : '#111417',
                        fontWeight: state.data?.isAddUrl ? '700' : '400',
                        backgroundColor: state.isSelected
                          ? 'rgba(58,181,73,0.12)'
                          : state.isFocused
                            ? '#f3f5f7'
                            : '#ffffff',
                        borderLeft: state.data?.isAddUrl ? '3px solid #3AB549' : '3px solid transparent',
                        cursor: 'pointer',
                      }),
                      singleValue: (base, state) => ({
                        ...base,
                        color: state.data?.isAddUrl ? '#3AB549' : '#111417',
                        fontWeight: state.data?.isAddUrl ? '700' : '400',
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: '#7a7f87',
                      }),
                      input: (base) => ({
                        ...base,
                        color: '#111417',
                      }),
                    }}
                    maxMenuHeight={150}
                    menuShouldScrollIntoView={true}
                    menuPlacement="top"
                  />
                </div>

                {showUrlField && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      width: 225,
                      marginTop: 10,
                      alignSelf: 'center',
                      backgroundColor: '#161B20',
                      border: '1px solid rgba(58,181,73,0.35)',
                      borderRadius: 8,
                      padding: 10,
                      boxSizing: 'border-box',
                    }}
                  >
                    <text
                      style={{
                        textAlign: 'left',
                        fontWeight: '600',
                        fontSize: 14,
                        color: '#3AB549',
                        marginBottom: 6,
                      }}
                    >
                      External Url
                    </text>

                    <input
                      type="text"
                      value={urlInput}
                      onChange={(e) => setUrlInput(e.target.value)}
                      placeholder="https://example.com"
                      style={{
                        width: '100%',
                        height: 42,
                        borderRadius: 6,
                        border: '1px solid #3a3f45',
                        backgroundColor: '#1a1f24',
                        color: 'white',
                        paddingLeft: 10,
                        paddingRight: 10,
                        outline: 'none',
                        fontSize: 14,
                        boxSizing: 'border-box',
                      }}
                    />

                    <text
                      style={{
                        marginTop: 6,
                        fontSize: 11,
                        color: 'rgba(255,255,255,0.65)',
                        textAlign: 'left',
                      }}
                    >
                      Please enter a full link starting with https://
                    </text>
                  </div>
                )}

                {curr_content != null && !showUrlField ? (
                  <div style={{ marginTop: 8 }}>
                    <ImagePreviewCard
                      imageUrl={curr_content.uri}
                      title={decrypt(curr_content.name)}
                    />
                  </div>
                ) : null}
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: 225,
                  marginTop: 3,
                  alignSelf: 'center',
                  opacity: curr_duration == 0 ? 1 : 0.7,
                }}
              >
                <text
                  style={{
                    textAlign: 'left',
                    fontWeight: '400',
                    fontSize: 15,
                    color: 'white',
                  }}
                >
                  Timing of content{' '}
                  <text
                    style={{
                      color: 'white',
                      fontSize: 12,
                      fontWeight: '600',
                    }}
                  >
                    {curr_duration != 0 ? `- Current Video length ${float2int(curr_duration)} s` : null}
                  </text>
                </text>

                <div style={{ display: 'flex', width: 225, marginTop: 5 }}>
                  <Select
                    onChange={(e) => {
                      setTiming(e.sec);
                    }}
                    options={seconds}
                    isDisabled={curr_duration != 0 || showUrlField}
                    placeholder={timing == 0 ? 'Select timing' : timing + " s"}
                    className="basic-single"
                    classNamePrefix="select"
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        textAlign: "left",
                        fontWeight: '400',
                        fontSize: 15,
                      }),
                    }}
                    maxMenuHeight={120}
                    menuShouldScrollIntoView={true}
                  />
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  width: 225,
                  marginTop: 3,
                  alignSelf: 'center',
                }}
              >
                {full_time ? (
                  <FaRegCheckSquare
                    onClick={() => {
                      setFullTime(!full_time);
                    }}
                    color="white"
                    size={20}
                  />
                ) : (
                  <MdCheckBoxOutlineBlank
                    onClick={() => {
                      setFullTime(!full_time);
                    }}
                    color="white"
                    size={20}
                  />
                )}
                <text
                  style={{
                    color: 'white',
                    fontWeight: '400',
                    fontSize: 15,
                    marginLeft: 5,
                  }}
                >
                  24 Hours
                </text>
              </div>

              <div
                style={{
                  opacity: full_time ? 0.5 : 1,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  width: 225,
                  marginTop: 1,
                  alignSelf: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    width: 225,
                    marginTop: 5,
                    alignSelf: 'center',
                  }}
                >
                  <text
                    style={{
                      textAlign: 'left',
                      fontWeight: '400',
                      fontSize: 15,
                      color: (((start != null && start.type != undefined) || full_time) ? 'white' : 'red'),
                    }}
                  >
                    Time from
                  </text>

                  <div
                    style={{
                      display: 'flex',
                      width: 224,
                      marginTop: 5,
                      alignItems: 'center',
                      flexDirection: 'row',
                      justifyContent: 'space-around',
                    }}
                  >
                    <div style={{ display: 'flex', width: 120 }}>
                      <Select
                        onChange={(e) => {
                          setStart({ ...start, hr: e.hour, min: e.min });
                        }}
                        options={times}
                        placeholder={'3 : 20'}
                        className="basic-single1"
                        classNamePrefix="select"
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            textAlign: "left",
                            fontWeight: '400',
                            fontSize: 15,
                          }),
                        }}
                        maxMenuHeight={180}
                        menuShouldScrollIntoView={true}
                        menuPlacement="top"
                        isDisabled={full_time}
                      />
                    </div>

                    <div style={{ display: 'flex', width: 100 }}>
                      <Select
                        onChange={(e) => {
                          setStart({ ...start, type: e.label });
                        }}
                        options={[
                          { label: 'AM', value: 'AM' },
                          { label: 'PM', value: 'PM' },
                        ]}
                        placeholder={'AM/PM'}
                        className="basic-single1"
                        classNamePrefix="select"
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            textAlign: "left",
                            fontWeight: '400',
                            fontSize: 15,
                          }),
                        }}
                        maxMenuHeight={180}
                        menuShouldScrollIntoView={true}
                        menuPlacement="top"
                        isDisabled={full_time}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  opacity: full_time ? 0.5 : 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: 225,
                  marginTop: 1,
                  alignSelf: 'center',
                }}
              >
                <text
                  style={{
                    textAlign: 'left',
                    fontWeight: '400',
                    fontSize: 15,
                    color: (((end != null && end.type != undefined) || full_time) ? 'white' : 'red'),
                  }}
                >
                  Until
                </text>

                <div
                  style={{
                    display: 'flex',
                    width: 224,
                    marginTop: 4,
                    alignItems: 'center',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                  }}
                >
                  <div style={{ display: 'flex', width: 120 }}>
                    <Select
                      onChange={(e) => {
                        setEnd({ ...end, hr: e.hour, min: e.min });
                      }}
                      options={times}
                      placeholder={'4 : 20'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400',
                          fontSize: 15,
                        }),
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement="top"
                      isDisabled={full_time}
                    />
                  </div>

                  <div style={{ display: 'flex', width: 100 }}>
                    <Select
                      onChange={(e) => {
                        setEnd({ ...end, type: e.label });
                      }}
                      options={[
                        { label: 'AM', value: 'AM' },
                        { label: 'PM', value: 'PM' },
                      ]}
                      placeholder={'AM/PM'}
                      className="basic-single1"
                      classNamePrefix="select"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          textAlign: "left",
                          fontWeight: '400',
                          fontSize: 15,
                        }),
                      }}
                      maxMenuHeight={180}
                      menuShouldScrollIntoView={true}
                      menuPlacement="top"
                      isDisabled={full_time}
                    />
                  </div>
                </div>
              </div>

              <div
                hidden={loading}
                onMouseDown={() => toggleTouched1()}
                onMouseUp={() => handleMouseUp1()}
                onClick={() => add_to_calendar()}
                style={{
                  height: 53,
                  alignSelf: 'center',
                  opacity: touched1 ? 0.3 : 1,
                  transition: 'opacity 300ms ease',
                  borderRadius: '5px',
                  outline: 'none',
                  marginTop: '25px',
                  width: 190,
                  backgroundColor: '#3AB549',
                  display: 'flex',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  alignItems: 'center',
                  marginBottom: 14,
                }}
              >
                <text
                  style={{
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: 17,
                  }}
                >
                  Submit
                </text>
              </div>
            </div>
          </div>
        </div>
      )}

      {cursor_img ? <img src={cursor_img} style={{ objectFit: 'contain', position: 'absolute', top: 400, left: 5, height: 250, width: (0.20 * width) - 10 }} /> : null}
      {cursor_vid ? <video autoPlay src={cursor_vid} style={{ objectFit: 'contain', position: 'absolute', top: 400, left: 5, height: 250, width: (0.20 * width) - 10 }} /> : null}

      {!isMobile && <ReactModal
        style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', bottom: '50%' }, content: { display: 'flex', position: 'absolute', top: '5%', left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 300, justifyContent: 'center', zIndex: 10000 } }}
        isOpen={delete_content != false}
        onRequestClose={() => { setDeleteContent(false) }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417', zIndex: 60000 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '89%', alignSelf: 'center' }}>
            <text></text>
            <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={34} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 25 }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>Are you sure to delete this content ?</text></div>

            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 20, cursor: 'pointer' }}>
              <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 53, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'white', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
              <div onClick={() => setDeleteContent(false)} style={{ height: 53, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 10 }}>
                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>}


      {isMobile && delete_content != false && <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 350, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 350) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 350, borderWidth: 2, borderColor: 'white', borderStyle: 'solid', overflowY: 'auto' }}>


        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417', zIndex: 60000 }}>

          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '89%', alignSelf: 'center' }}>
            <text></text>
            <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={34} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 25 }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>Are you sure to delete this content ?</text></div>

            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 300, justifyContent: 'space-around', marginTop: 20, cursor: 'pointer' }}>
              <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 53, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'white', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
              <div onClick={() => setDeleteContent(false)} style={{ height: 53, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 10 }}>
                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
              </div>
            </div>
          </div>
        </div>
      </div>
      }


      {!isMobile && edit_second != null && <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417', width: 490, height: 410, position: 'fixed', top: '20%', alignSelf: 'center', borderWidth: 1, borderColor: 'white', borderStyle: 'solid', left: (width - 490) / 2 }}>

        <IoIosCloseCircle onClick={() => { setEditSecond(null); setSecond(0); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

        <div style={{ display: 'flex', flexDirection: 'column', width: 400, justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
          <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Update Content timing</text></div>

          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 400, marginTop: 15, alignSelf: 'center', opacity: curr_duration == 0 ? 1 : 0.7 }}>
            <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: 'white' }}>Timing of content <text style={{ color: 'white', fontSize: 12, fontWeight: '600' }}>{curr_duration != 0 ? `- Current Video length ${float2int(curr_duration)} s` : null}</text> </text>
            <div style={{ display: 'flex', width: 400, marginTop: 5 }}>
              <Select
                onChange={(e) => { setSecond(e.sec) }}
                options={seconds}
                placeholder={second + " s"}
                className="basic-single"
                classNamePrefix="select"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    textAlign: "left",
                    fontWeight: '400', fontSize: 15,
                  })
                }}
                maxMenuHeight={120}
                menuShouldScrollIntoView={true}
              />
            </div>
          </div>

          <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => { updateTiming() }} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Update</text> </div>
        </div>
      </div>}


      {isMobile && edit_second != null &&
        <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 350, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 350) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 350, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>


          <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417', height: 410, position: 'fixed', top: '20%', alignSelf: 'center', borderWidth: 1, borderColor: 'white', borderStyle: 'solid', left: (width - (0.97 * width)) / 2 }}>

            <IoIosCloseCircle onClick={() => { setEditSecond(null); setSecond(0); }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

            <div style={{ display: 'flex', flexDirection: 'column', width: 300, justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
              <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 24 }}>Update Content timing</text></div>

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: 300, marginTop: 15, alignSelf: 'center', opacity: curr_duration == 0 ? 1 : 0.7 }}>
                <text style={{ textAlign: 'left', fontWeight: '400', fontSize: 15, color: 'white' }}>Timing of content <text style={{ color: 'white', fontSize: 12, fontWeight: '600' }}>{curr_duration != 0 ? `- Current Video length ${float2int(curr_duration)} s` : null}</text> </text>
                <div style={{ display: 'flex', width: 300, marginTop: 5 }}>
                  <Select
                    onChange={(e) => { setSecond(e.sec) }}
                    options={seconds}
                    placeholder={second + " s"}
                    className="basic-single"
                    classNamePrefix="select"
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        textAlign: "left",
                        fontWeight: '400', fontSize: 15,
                      })
                    }}
                    maxMenuHeight={120}
                    menuShouldScrollIntoView={true}
                  />
                </div>
              </div>

              <div hidden={loading} onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => { updateTiming() }} style={{ height: 35, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', marginTop: '25px', width: 290, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Update</text> </div>
            </div>
          </div>
        </div>
      }



      <wc-toast></wc-toast>

    </div>
  );
}


const mapStateToProps = state => {
  //  console.log(state)
  return {
    items: state._todoProduct
  }
}

export default connect(mapStateToProps, { SetId })(Calendars)

/*

    <div style={{ marginLeft: 6, marginTop: 4 }}>
              <stripe-buy-button
                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
              >
              </stripe-buy-button>
            </div>

*/